// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionPushGiveUpDaysPropertyDto
 */
export interface IContributionPushGiveUpDaysPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IContributionPushGiveUpDaysPropertyDto
     */
    contribution_push_give_up_days?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionPushGiveUpDaysPropertyDto
     */
    contribution_push_give_up_days_state?: IContributionPushGiveUpDaysPropertyDtoContributionPushGiveUpDaysStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IContributionPushGiveUpDaysPropertyDtoContributionPushGiveUpDaysStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IContributionPushGiveUpDaysPropertyDto interface.
 */
export function instanceOfIContributionPushGiveUpDaysPropertyDto(value: object): value is IContributionPushGiveUpDaysPropertyDto {
    return true;
}

export function IContributionPushGiveUpDaysPropertyDtoFromJSON(json: any): IContributionPushGiveUpDaysPropertyDto {
    return IContributionPushGiveUpDaysPropertyDtoFromJSONTyped(json, false);
}

export function IContributionPushGiveUpDaysPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionPushGiveUpDaysPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_push_give_up_days': json['contribution_push_give_up_days'] == null ? undefined : json['contribution_push_give_up_days'],
        'contribution_push_give_up_days_state': json['contribution_push_give_up_days_state'] == null ? undefined : json['contribution_push_give_up_days_state'],
    };
}

export function IContributionPushGiveUpDaysPropertyDtoToJSON(json: any): IContributionPushGiveUpDaysPropertyDto {
    return IContributionPushGiveUpDaysPropertyDtoToJSONTyped(json, false);
}

export function IContributionPushGiveUpDaysPropertyDtoToJSONTyped(value?: IContributionPushGiveUpDaysPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_push_give_up_days': value['contribution_push_give_up_days'],
        'contribution_push_give_up_days_state': value['contribution_push_give_up_days_state'],
    };
}

